import React, { Suspense, useState, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NavBar from "./components/Shared/NavBar";
import Footer from "./components/Shared/Footer";
import FallbackLoading from "./components/Shared/FallbackLoading";
import { useSelector } from "react-redux";
import { NotFound } from "./components/Shared/NotFound";

const Login = lazy(() => import('./pages/Auth/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const Sidebar = lazy(() => import('./components/Shared/Sidebar'));
const Vehicles = lazy(() => import('./pages/Vehicles/VehicleRecords'));
const BrandRecords = lazy(() => import('./pages/Records/BrandRecords'));
const ModelRecords = lazy(() => import('./pages/Records/ModelRecords'));
const BrandCreate = lazy(() => import('./pages/Records/BrandCreate'));
const ModelCreate = lazy(() => import('./pages/Records/ModelCreate'));
const DriverRecordsNew = lazy(() => import('./pages/Drivers/DriverRecordsNew'));
const DriversCreateNew = lazy(() => import('./pages/Drivers/DriversCreateNew'));
const VehicleCreate = lazy(() => import('./pages/Vehicles/VehicleCreate'));
const AccountDetails = lazy(() => import('./pages/Account/AccountDetails'));
const ChangePassword = lazy(() => import('./pages/Auth/ChangePassword'));
const PartnerRecords = lazy(() => import('./pages/Partners/PartnerRecords'));
const PartnerCreateNew = lazy(() => import('./pages/Partners/PartnerCreateNew'));
const BookingRecords = lazy(() => import('./pages/Bookings/BookingRecords'));
const BookingCreate = lazy(() => import('./pages/Bookings/BookingCreate'));
const Booking = lazy(() => import('./pages/Bookings/Booking'));
const PartnerRecieverRecords = lazy(() => import('./pages/Partners/PartnerRecieverRecords'));
const PricingRecords = lazy(() => import('./pages/Pricing/PricingRecords'));
const PricingCreate = lazy(() => import('./pages/Pricing/PricingCreate'));
const StaffRecords = lazy(() => import('./pages/Staff/StaffRecords'));
const StaffCreate = lazy(() => import('./pages/Staff/StaffCreate'));
const PaymentsNew = lazy(() => import('./pages/Finance/PaymentsNew'));
const BookingPaymentHistory = lazy(() => import('./pages/Finance/BookingPaymentHistory'));

const RoutersNew = ({ language, setLanguage, handleLanguageChange }) => {
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const user = useSelector((state) => state.authReducer.user);

  const [title, setTitle] = useState();
  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <Suspense fallback={<FallbackLoading />}>
        <Router>
          <NavBar
            language={language}
            setLanguage={setLanguage}
            handleLanguageChange={handleLanguageChange}
            open={open}
            setOpen={setOpen}
            handleToggle={handleToggle}
            title={title}
            setTitle={setTitle}
          />
          <Sidebar open={open} setOpen={setOpen} handleToggle={handleToggle}>
            <Routes>
              {!isAuthenticated && (
                <>
                  <Route
                    path="/"
                    element={<Login isAuthenticated={isAuthenticated} />}
                  />
                </>
              )}
              {isAuthenticated && (
                <>
                  <Route
                    path="/"
                    element={<Dashboard isAuthenticated={isAuthenticated} />}
                  />
                  <Route path="account" element={<AccountDetails />} />
                  {user?.is_admin && (
                    <Route
                      path="account/changepassword"
                      element={<ChangePassword />}
                    />
                  )}

                  <Route path="bookings" element={<BookingRecords />} />
                  <Route path="bookings/create" element={<BookingCreate />} />
                  <Route
                    path="bookings/create/:id"
                    element={<BookingCreate />}
                  />
                  <Route
                    path="bookings/:id"
                    element={<Booking setTitle={setTitle} />}
                  />
                  <Route
                    path="bookings/details/:id"
                    element={<Booking type={"detail"} setTitle={setTitle} />}
                  />
                  <Route path="brands" element={<BrandRecords />} />
                  <Route path="brands/create" element={<BrandCreate />} />
                  <Route path="brands/create/:id" element={<BrandCreate />} />
                  <Route path="brands/models" element={<ModelRecords />} />
                  <Route
                    path="brands/models/create"
                    element={<ModelCreate />}
                  />
                  <Route
                    path="brands/models/create/:id"
                    element={<ModelCreate />}
                  />

                  <Route path="vehicles" element={<Vehicles />}></Route>
                  <Route path="vehicles/create" element={<VehicleCreate />} />
                  <Route
                    path="vehicles/create/:id"
                    element={<VehicleCreate />}
                  />

                  <Route path="drivers" element={<DriverRecordsNew />} />
                  <Route path="drivers/create" element={<DriversCreateNew />} />
                  <Route
                    path="drivers/create/:id"
                    element={<DriversCreateNew />}
                  />

                  <Route path="partners" element={<PartnerRecords />} />
                  <Route
                    path="partners/recievers"
                    element={<PartnerRecieverRecords />}
                  />

                  <Route
                    path="partners/create"
                    element={<PartnerCreateNew />}
                  />
                  <Route
                    path="partners/recievers/create"
                    element={<PartnerCreateNew type="recievers" />}
                  />

                  <Route
                    path="partners/create/:id"
                    element={<PartnerCreateNew />}
                  />
                  <Route
                    path="partners/recievers/create/:id"
                    element={<PartnerCreateNew type="recievers" />}
                  />
                  <Route path="pricing" element={<PricingRecords />} />
                  <Route path="pricing/create" element={<PricingCreate />} />
                  <Route
                    path="pricing/create/:id"
                    element={<PricingCreate />}
                  />
                  {user?.is_admin && (
                    <>
                      <Route path="staff" element={<StaffRecords />} />
                      <Route path="staff/create" element={<StaffCreate />} />
                      <Route
                        path="staff/create/:id"
                        element={<StaffCreate />}
                      />
                    </>
                  )}
                  {/* <Route path="finance" element={<Payments />} /> */}
                  <Route path="finance" element={<PaymentsNew />} />

                  {/* <Route path="finance/payouts" element={<Payouts />} /> */}
                  <Route
                    path="finance/bookinghistory"
                    element={<BookingPaymentHistory />}
                  />
                </>
              )}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Sidebar>
          <Footer />
        </Router>
      </Suspense>
    </>
  );
};

export default RoutersNew;
